import { createApi } from '@reduxjs/toolkit/query/react';
import { createApiConfig } from '../../../../createApiConfig';

export const lmIptvFilesApi = createApi({
  reducerPath: 'lmIptvFilesApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: ['IPTV | Media Files'],
  endpoints: builder => ({
    getIptvMediaFilesList: builder.query({
      query: (params) => ({
        url: '/links/iptv-media-files/',
        params,
      }),
      providesTags: ['IPTV | Media Files'],
    }),

    createIptvMediaFile: builder.mutation({
      query: (data) => ({
        url: '/links/iptv-media-files/',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['IPTV | Media Files'],
    }),

    getIptvMediaFileById: builder.query({
      query: (id) => ({
        url: `/links/iptv-media-files/${id}`,
      }),
      providesTags: ['IPTV | Media Files'],
    }),

    updateIptvMediaFileById: builder.mutation({
      query: ({ id, data }) => ({
        url: `/links/iptv-media-files/${id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['IPTV | Media Files'],
    }),

    deleteIptvMediaFileById: builder.mutation({
      query: (id) => ({
        url: `/links/iptv-media-files/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['IPTV | Media Files'],
    }),
  }),
});

export const {
  useGetIptvMediaFilesListQuery,
  useCreateIptvMediaFileMutation,
  useGetIptvMediaFileByIdQuery,
  useUpdateIptvMediaFileByIdMutation,
  useDeleteIptvMediaFileByIdMutation,
} = lmIptvFilesApi;
